import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RatePlans from '../discounts/rate-plans';
import RatePlanAddOns from '../discounts/rate-plan-addons';
import RatePlanPromos from '../discounts/rate-plan-promos';

const UI = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/rate-promos`} />
            <Route path={`${match.url}/rate-plans`} component={RatePlans} />
            <Route
                path={`${match.url}/rate-plan-addons`}
                component={RatePlanAddOns}
            />
            <Route
                path={`${match.url}/rate-plan-promos`}
                component={RatePlanPromos}
            />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default UI;
